import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import Header from "../Header";
import Item from "./Item";
import getClassNameFactory from "../../../../utilities/classNames";
export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren) {
    var getClassName, className, childrenNode, reactifiedChildren, getHeaderClassName, headingInnerClassName, headingInnerNode, reactifiedHeadingInner, rehydrationProps;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getClassName = getClassNameFactory(Item.displayName);
            className = getClassName({
              descendantName: "content"
            });
            childrenNode = domNode.querySelector(".".concat(className));
            _context.next = 5;
            return rehydrateChildren(childrenNode);

          case 5:
            reactifiedChildren = _context.sent;

            /*
             * Reach insisde Header subcomponent in order to rehydrate the children of
             * it's internal Heading component.
             */
            getHeaderClassName = getClassNameFactory(Header.displayName);
            headingInnerClassName = getHeaderClassName({
              descendantName: "headingInner"
            });
            headingInnerNode = domNode.querySelector(".".concat(headingInnerClassName));
            _context.next = 11;
            return rehydrateChildren(headingInnerNode);

          case 11:
            reactifiedHeadingInner = _context.sent;
            rehydrationProps = {
              id: domNode.getAttribute("data-id"),
              dataAnalyticsElementType: domNode.getAttribute("data-analytics-element-type"),
              isExpanded: domNode.getAttribute("data-is-expanded") === "true" || false,
              isAccordion: domNode.getAttribute("data-is-accordion") === "true" || false,
              headingRank: domNode.getAttribute("data-heading-rank"),
              title: reactifiedHeadingInner,
              header: Item.defaultProps.header
            };
            return _context.abrupt("return", /*#__PURE__*/React.createElement(Item, rehydrationProps, reactifiedChildren));

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
})();